import { render, staticRenderFns } from "./TariffCard.vue?vue&type=template&id=d9ab0c64&"
import script from "./TariffCard.vue?vue&type=script&lang=js&"
export * from "./TariffCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports